import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Link from '@material-ui/core/Link';

import { fractionToPercent } from 'helpers/helpers';
import useStyles from './simpleStyles';
import { AssetCategory, BucketAssetClass, ClassesAsset } from 'common/interfaces';

interface Props {
  data: AssetCategory[];
  savingIsins: string[];
}

const PortfolioTable = (props: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { data, savingIsins } = props;

  return (
    <>
      <Table className={classes.root}>
        <TableHead>
          <TableRow className={classes.assetRow}>
            <TableCell className={'categoryHeader'}>
              {t('accountPlan_selected_category')}
              <br />
              {t('accountPlan_selected_asset')}
            </TableCell>
            <TableCell className={classes.isinCol}>{t('accountPlan_portfolioTable_ISIN')}</TableCell>
            <TableCell align="center">{t('accountPlan_portfolioTable_terTitle')}</TableCell>
            <TableCell align="center">{t('accountPlan_targetShare')}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((assetCategory: AssetCategory, catKey: number) => {
            return (
              <React.Fragment key={assetCategory.code}>
                <TableRow key={assetCategory.code} className={classes.category}>
                  <TableCell scope="row" className="categoryTitle">
                    <strong>{t(assetCategory.title)}</strong>
                  </TableCell>
                  <TableCell className={classes.isinCol} />
                  <TableCell />
                  <TableCell align="center" className="categoryShare">
                    {fractionToPercent(assetCategory.share)}
                  </TableCell>
                  <TableCell className={classes.kiidCol} />
                </TableRow>

                {assetCategory.assetClasses.map((row: BucketAssetClass, key: number) => (
                  <React.Fragment key={`${row.code}_${key}`}>
                    {row.assets &&
                      row.assets.map((asset: ClassesAsset, i: number) => (
                        <React.Fragment key={asset.code}>
                          <TableRow className={classes.assetRow}>
                            <TableCell scope="row" className={'titleCell'}>
                              <strong>{asset.title}</strong>
                              <br />
                              {asset.originalTitle}
                              <div className={classes.isinBlock}>
                                {savingIsins?.includes(asset.isin) ? (
                                  ''
                                ) : (
                                  <>
                                    <strong>{t('accountPlan_portfolioTable_ISIN')}</strong>: {asset.isin}
                                  </>
                                )}
                              </div>
                              {asset.kid && (
                                <div className={classes.kiidBlock}>
                                  <Link target="_blank" href={asset.kid}>
                                    {t('accountPlan_portfolioTable_KIID')}
                                  </Link>
                                </div>
                              )}
                            </TableCell>
                            <TableCell className={classes.isinCol}>
                              {savingIsins?.includes(asset.isin) ? '' : asset.isin}
                            </TableCell>
                            <TableCell align="center">
                              {typeof asset.ter === 'number' && fractionToPercent(asset.ter, 2)}
                            </TableCell>
                            <TableCell align="center">{fractionToPercent(asset.share)}</TableCell>
                            <TableCell align="center" className={classes.kiidCol}>
                              {asset.kid && (
                                <Link target="_blank" href={asset.kid}>
                                  {t('accountPlan_portfolioTable_KIID')}
                                </Link>
                              )}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};

export default PortfolioTable;
